
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Plant_list } from '../models/index';
import { AppConstants } from '../constant/app.constants';

@Injectable()
export class Plant_listsService {
    constructor(private http: HttpClient) {
    }

    getAllPlant_lists() {
        return this.http.get<any>(AppConstants.SITE_URL + 'plant_list/get_all_plant_lists');
    }
    getAllMachine_lists() {
        return this.http.get<any>(AppConstants.SITE_URL + 'machine_list/get_all_machine_lists');
    }
    getAllPlant_listsByUserRole(user_id, role_id) {
        return this.http.post<any>(AppConstants.SITE_URL + 'plant_list/get_plant_lists_by_user_role', { role_id: role_id, user_id: user_id });
    }
    getPlant_lists(plant_list: Plant_list) {
        return this.http.post<any>(AppConstants.SITE_URL + 'plant_list/get_plant_lists', plant_list);
    }

    getPlant_list_by_installer(plant_list: Plant_list) {
        return this.http.post<any>(AppConstants.SITE_URL + 'plant_list/get_plant_list_by_installer', plant_list);
    }

    getPlant_listById(id) {
        return this.http.post<any>(AppConstants.SITE_URL + 'plant_list/get_plant_listById', { id: id });
    }

    getMachine_list_table_data(machine_id, plant_id) {
        return this.http.post<any>(AppConstants.SITE_URL + 'machine_list/get_machine_list_table_data', { plant_id: plant_id, machine_id: machine_id });
    }

    getMachine_list_by_plant(plant_list: Plant_list) {
        return this.http.post<any>(AppConstants.SITE_URL + 'machine_list/get_machine_listBy_plant', plant_list);
    }

    check_mail_exists(emailAndRoleId) {
        return this.http.post<any>(AppConstants.SITE_URL + 'plant_list/check_mail_exists', emailAndRoleId);
    }

    check_mail_exists_multiple(emailsAndRoleId) {
        return this.http.post<any>(AppConstants.SITE_URL + 'plant_list/check_mail_exists_multiple', emailsAndRoleId);
    }

    savePlant_list(plant_list) {
        return this.http.post<any>(AppConstants.SITE_URL + 'plant_list/save_plant_list', plant_list);
    }

    deletePlant_list(id) {
        return this.http.post<any>(AppConstants.SITE_URL + 'plant_list/delete_plant_list', { id: id });
    }

    deletePlant_machine(id) {
        return this.http.post<any>(AppConstants.SITE_URL + 'plant_list/delete_plant_machine', { id: id });
    }

    checkPlant_subcategoryPresent(sku) {
        return this.http.get<any>(AppConstants.SITE_URL + 'plant_list/check_plant_subcategory_present/' + sku);
    }
    
    disableInstaller(plant_listId) {
        return this.http.post<any>(AppConstants.SITE_URL + 'plant_list/' + plant_listId + '/installer/disable', {});
    }

    disableDistributor(plant_listId) {
        return this.http.post<any>(AppConstants.SITE_URL + 'plant_list/' + plant_listId + '/distributor/disable', {});
    }
}



// WEBPACK FOOTER //
// /var/www/delios/delios-live/app/src/app/services/plant_lists.service.ts